"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAirOut = calculateAirOut;
exports.calculatePower = calculatePower;
exports.setPropertiesAirIn = setPropertiesAirIn;
exports.setPropertiesAirOut = setPropertiesAirOut;
exports.setPropertiesPower = setPropertiesPower;
function calculateAirOut() {
    return {
        type: "air-power-tool/CALCULATE-AIR-OUT"
    };
}
function calculatePower() {
    return {
        type: "air-power-tool/CALCULATE-POWER"
    };
}
function setPropertiesAirIn(pvs) {
    return {
        type: "air-power-tool/SET-PROPERTIES-AIR-IN",
        payload: pvs
    };
}
function setPropertiesAirOut(pvs) {
    return {
        type: "air-power-tool/SET-PROPERTIES-AIR-OUT",
        payload: pvs
    };
}
function setPropertiesPower(pvs) {
    return {
        type: "air-power-tool/SET-PROPERTIES-POWER",
        payload: pvs
    };
}
//# sourceMappingURL=actions.js.map